<template lang="pug">
  ValidationProvider(:rules="'required|exist_deliver_type'" v-slot="{ errors }" name="出荷属性" :immediate="immediate" v-if="doValidate")
    b-field(:type="{'is-danger': errors.length > 0 }" :message="errors[0]")
      b-autocomplete(
        data-vv-as="出荷属性"
        :name="input_name"
        size="is-small"
        v-model="internalValue"
        :disabled="disabled"
        :loading="loading"
        :data="filteredDataObj"
        field="formattedName"
        open-on-focus
        class="fully-visible-autocomplete"
      )
      | {{ deliverTypeName }}
  b-field(:type="{'is-danger': error(input_name, custom_errors) }" :message="errorMessageFor(input_name, custom_errors)" v-else)
    b-autocomplete(
      data-vv-as="出荷属性"
      :name="input_name"
      size="is-small"
      v-model="internalValue"
      :disabled="disabled"
      :loading="loading"
      :data="filteredDataObj"
      field="formattedName"
      open-on-focus
      class="fully-visible-autocomplete"
    )
    | {{ deliverTypeName }}

</template>

<script>
  import ErrorDisplayer from 'mixins/error_displayer'
  import { ValidationProvider, Validator } from 'vee-validate'

  export default {
    name: 'deliver-type-id-input',
    mixins: [ErrorDisplayer],
    components: {
      ValidationProvider
    },
    data() {
      return {
      }
    },
    props: {
      input_name: {
        type: String,
        required: true
      },
      value: {
        type: Number,
      },
      disabled: {
        type: Boolean,
        required: false
      },
      deliver_types: {
        type: Array,
        required: true,
        default: []
      },
      custom_errors: {
        required: false
      },
      // ValidationProviderによるvalidationをするか
      doValidate: {
        type: Boolean,
        required: false,
        default: true
      },
      immediate: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    computed: {
      loading(){
        return 0 == this.deliver_types.length
      },
      internalValue: {
        get() {
          return this.value
        },
        set(newVal) {
          var deliverTypeId = this.deliverTypeId(newVal)
          if (this.value !== deliverTypeId) this.$emit('input', deliverTypeId)
        }
      },
      deliverTypeName() {
        var obj = this.deliver_types.filter((deliver_type) => {
          return deliver_type.id == this.internalValue
        })
        if(obj.length == 1) {
          return obj[0].name
        } else {
          return ""
        }
      },
      filteredDataObj() {
        return this.deliver_types.filter((deliver_type) => {
          this.setFormattedName(deliver_type)
          return `${deliver_type.id} ${deliver_type.name}`.indexOf(this.internalValue) >= 0
        })
      }
    },
    methods: {
      deliverTypeId(value) {
        var deliverTypes = this.deliver_types.filter((deliver_type) => {
          // id or id + 名前 or 名前が一致するかどうか
          if(deliver_type.id == value || deliver_type.formattedName == value || deliver_type.name == value)
            return true
        })
        if(deliverTypes.length == 1) {
          return deliverTypes[0].id
        } else {
          return value
        }
      },
      setFormattedName(deliver_type) {
        deliver_type.formattedName = deliver_type.id + ' ' + deliver_type.name
      },
      setValidationRule() {
        Validator.extend('exist_deliver_type', {
          getMessage: field => `${field}は存在しません`,
          validate: value => {
            return this.deliver_types.some(deliver_type => deliver_type.id == value)
          }
        })
      }
    },
    created() {
      if(this.doValidate) this.setValidationRule()
    },
  }
</script>
